module.exports = __webpack_public_path__ + "img/Branding.a730d5e7.jpg";